import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DisplayError from '../../../../components/info/DisplayError';
import useUserState from '../../../../hooks/useUserState';
import { PermissionName } from '../../../../types/Auth';
import AsyncOptionsFieldsLoader from '../../../StudentFileAsyncOptions/AsyncOptionsFieldsLoader';
import { AsynOptionsFieldsOrigin } from '../../../StudentFileAsyncOptions/types';
import PostulantLoader from '../../loaders/PostulantLoader';
import StudentTabsHeader from '../StudentTabsHeader';
import PostulantUpdateForm from './parts/PostulantUpdateForm';

export default function StudentPersonalInformation() {
  const { t } = useTranslation();
  const { isAuthorizedTo } = useUserState();
  const history = useHistory();

  const hasPermission = useMemo(
    () =>
      isAuthorizedTo([PermissionName.STUDENT_MANAGEMENT_STUDENT_FILE], true),
    [isAuthorizedTo],
  );
  return hasPermission ? (
    <AsyncOptionsFieldsLoader from={AsynOptionsFieldsOrigin.StudentFile}>
      {() => (
        <PostulantLoader>
          {(props) => {
            return (
              <>
                <StudentTabsHeader
                  name={props?.postulant?.fullName}
                  id={props?.postulant?.rut}
                />
                <PostulantUpdateForm
                  prefix="tuitionProcess.onSite"
                  postulantId={props?.postulant?.id}
                  defaultValues={props?.defaultValues}
                  photo={props?.photo}
                  onError={() => {}}
                />
              </>
            );
          }}
        </PostulantLoader>
      )}
    </AsyncOptionsFieldsLoader>
  ) : (
    <DisplayError
      insideCard
      textBody={t('common.errors.permissions')}
      buttonText={t('common.actions.back')}
      retryAction={() => history?.goBack()}
    />
  );
}
